import EditLink from '~shared/EditLink'
import { useLayoutEffect, useRef } from 'react'
import { getEventSubTitle } from '~utils/seo'
import { GetEventAuctionByIdQuery } from 'gql'
import Typography from '~ui/Typography'

import styles from './title.module.scss'

type DesctiptionProps = {
  findArtwork: Pick<
    GetEventAuctionByIdQuery['findArtwork'],
    'id' | 'title' | 'venue' | 'eventStartDateLocal'
  >
}

const TitleDesctiption: React.FC<DesctiptionProps> = ({ findArtwork }) => {
  const { id, title } = findArtwork
  const subtitle = getEventSubTitle(findArtwork)
  const titleRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    document.body.style.setProperty(
      '--title-height',
      titleRef?.current ? `${titleRef?.current.offsetHeight}px` : null
    )
  })

  return (
    <div className={styles.title} ref={titleRef}>
      {title && <h1>{title}</h1>}
      {subtitle && <Typography.Text color="light-gray">{subtitle}</Typography.Text>}
      {id && (
        <div>
          <EditLink entityType="BUY_IT_NOW_OPTION" id={id} />
        </div>
      )}
    </div>
  )
}

export default TitleDesctiption
